import React, {Component} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import styled from 'styled-components';
import {createMuiTheme, MuiThemeProvider} from '@material-ui/core/styles';
import {blueGrey} from "@material-ui/core/colors";
import 'moment/locale/pl';
import AuthView from './Views/AuthView';
import ActionCreators from './store/actions';
import Axios from './config/AxiosConfig';
import Routes from './Routes';
import Spinner from './Components/SpinnerComponent/SpinnerComponent';
import Snackbar from './Components/SnackbarComponent/RequestSnackbar';
import './App.css';
import CookiesInfoBar from "./Components/Utilities/Cookies/CookieInfoBar";
import SessionExpirationSnackbar from './Components/SnackbarComponent/SessionExpirationSnackbar';


const StyledApp = styled.div`
  height: 100vh;
  overflow: hidden;
  position: relative;
`;

const theme = () => ({
    palette: {
        type: "light",
        primary: {
            main: "#A3A0FB"
        },
        secondary: blueGrey,
    },
    typography: {
        fontFamily: [
            "ToyotaDisplay-Regular,Roboto"
        ].join(','),
        h3: {
            fontSize: "2.5rem"
        },
        subtitle2: {
            fontSize: "1rem",
            fontWeight: 500,
            lineHeight: 1.75
        },
        body1: {
            fontWeight: 400,
            fontSize: "0.875rem",
            lineHeight: 1.43,
            letterSpacing: "0.01071em",
        },
        body2: {
            fontSize: "0.75rem"
        }
    },
});

class App extends Component {
    constructor(props) {
        super(props);
        Axios.interceptors.response.use(null, e => {
            //Global error handler for HTTP requests
            const errorMessage = e.response.data.status.message;
            this.props.openSnackbar(errorMessage);
            if (errorMessage === "Nieprawidlowy token") {
                this.props.logout();
            }
        });
    }

    componentDidUpdate(prevProps) {
        if(this.props.token !== null && typeof this.props.token === 'string' && this.checkTokenInterval === undefined)
            this.checkTokenInterval = setInterval(this.props.checkToken, 60000);
        else if(typeof prevProps.token === 'string' && this.props.token === null)
            clearInterval(this.checkTokenInterval);
    }

    componentWillUnmount() {
        clearInterval(this.checkTokenInterval);
    }

    render() {
        const {token = null, isLoader = false} = this.props;
        const muiTheme = createMuiTheme(theme());

        return (
            <MuiThemeProvider theme={muiTheme}>
                <StyledApp>
                    <Snackbar/>
                    <SessionExpirationSnackbar />
                    {isLoader && <Spinner/>}
                    {token ? <Routes/> : <AuthView/>}
                    <CookiesInfoBar />
                </StyledApp>
            </MuiThemeProvider>
        );
    }
}

const mapStateToProps = state => {
    return {
        token: state.authReducer.token,
        isLoader: state.requestReducer.isLoader
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActionCreators, dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(App);
